module.exports = __webpack_public_path__ + "static/media/IRANSansWeb.c26a9eb2.ttf";